import {
  committeeFetchActionHandler,
  committeeByIdFetchActionHandler,
  committeeCreateActionHandler,
  committeeUpdateActionHandler,
  committeeDeleteActionHandler,
} from "./committee/committee";

import {
  demandFetchActionHandler,
  demandByIdFetchActionHandler,
  demandCreateActionHandler,
  demandUpdateActionHandler,
  demandDeleteActionHandler,
} from "./demand/demand";

import {
  appByIdFetchActionHandler,
  appCreateActionHandler,
  appDeleteActionHandler,
  appFetchActionHandler,
  appUpdateActionHandler,
} from "./annualProcurementPlan/annualProcurementPlan";

import {
  vendorByIdFetchActionHandler,
  vendorCreateActionHandler,
  vendorDeleteActionHandler,
  vendorFetchActionHandler,
  vendorUpdateActionHandler,
} from "./vendors/vendor";

import {
  procurementFetchActionHandler,
  procurementCreateActionHandler,
  procurementByIdFetchActionHandler,
  procurementUpdateActionHandler,
} from "./procurements/procurement";

import {
  createTenderNoticePublication,
  fetchTNPDetails,
} from "./procurements/tenderNoticePublication/tenderNoticePublication";
import { createNOA, fetchNOADetails } from "./procurements/NOA/NOA";
import {
  createAgreement,
  fetchAgreementDetails,
} from "./procurements/agreement/agreement";

import {
  packageByIdFetchActionHandler,
  packageCreateActionHandler,
  packageDeleteActionHandler,
  packageFetchActionHandler,
  packageUpdateActionHandler,
} from "./package/package";

const procurementsActionsHandlers = {
  committeeFetchActionHandler,
  committeeByIdFetchActionHandler,
  committeeCreateActionHandler,
  committeeUpdateActionHandler,
  committeeDeleteActionHandler,

  demandFetchActionHandler,
  demandByIdFetchActionHandler,
  demandCreateActionHandler,
  demandUpdateActionHandler,
  demandDeleteActionHandler,

  // APP
  appByIdFetchActionHandler,
  appCreateActionHandler,
  appDeleteActionHandler,
  appFetchActionHandler,
  appUpdateActionHandler,

  // Vendor
  vendorByIdFetchActionHandler,
  vendorCreateActionHandler,
  vendorDeleteActionHandler,
  vendorFetchActionHandler,
  vendorUpdateActionHandler,

  // Procurement
  procurementFetchActionHandler,
  procurementCreateActionHandler,
  procurementUpdateActionHandler,
  procurementByIdFetchActionHandler,
  createTenderNoticePublication,
  fetchTNPDetails,
  createNOA,
  fetchNOADetails,
  createAgreement,
  fetchAgreementDetails,

  // package

  packageByIdFetchActionHandler,
  packageCreateActionHandler,
  packageDeleteActionHandler,
  packageFetchActionHandler,
  packageUpdateActionHandler,
};

export default procurementsActionsHandlers;
